import { SEPOLIA } from '../types';
export default {
  type: SEPOLIA,
  service: 'myetherwallet.com-ws',
  url: 'wss://nodes.mewapi.io/ws/sepolia',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
